module.exports = __webpack_public_path__ + "img/client7.062431bc.png";